import { Waves, Snowflake, Car, Bell, Sparkles, Clock, Tv, Droplets, Users, Utensils, Wifi, Bus, Zap } from "lucide-react";

export const FACILITY_ICONS = {
  waves: Waves,
  snowflake: Snowflake,
  car: Car,
  bell: Bell,
  sparkles: Sparkles,
  clock: Clock,
  tv: Tv,
  droplets: Droplets,
  users: Users,
  utensils: Utensils,
  wifi: Wifi,
  bus: Bus,
  zap: Zap,
};
